/** Members of `left` not in `right`; avoids `Set.prototype.difference` for older Chromium. */
export function setDifference<T>(
  left: ReadonlySet<T>,
  right: ReadonlySet<T>,
): Set<T> {
  const out = new Set<T>();
  for (const value of left) {
    if (!right.has(value)) {
      out.add(value);
    }
  }
  return out;
}
